/**
 * @type {Object.<string, RegExp>}
 */
const regexes = {
    // Cases:
    //  www.cases.media, cases.media
    'icon-pacman': /^(?:https?:\/\/)?(?:www\.)?cases\.media(?:\/|$)/,

    // Instagram:
    //  www.instagram.com, m.instagram.com, instagram.cpm
    //  www.instagr.am, instagr.am
    //  www.instarg.com, instagr.com
    'icon-ic-instagram': /^(?:https?:\/\/)?(?:(?:www\.|m\.)?instagram\.com|(?:www\.)?instagr\.(?:com|am))(?:\/|$)/,

    // Telegram:
    //  www.telegram.me, telegram.me
    //  www.t.me, t.me
    'icon-ic-telegram-logo': /^(?:https?:\/\/)?(?:www\.)?(?:t|telegram)\.me(?:\/|$)/,

    // Facebook:
    //  www.facebook.com, mbasic.facebook.com, m.facebook.com, facebook.com
    //  www.fb.me, mbasic.fb.me, m.fb.me, fb.me
    //  www.fb.com, fb.com
    //  www.facebook.me, facebook.me
    //  www.fb.me, fb.me
    'icon-ic-facebook-circle': /^(?:https?:\/\/)?(?:(?:www\.|mbasic\.|m\.)?(?:facebook\.com|fb\.me)|(www\.)?(fb\.com|facebook\.me|fb\.me))(?:\/|$)/,

    // Twitter: (no, I will not check for X)
    //  mobile.twitter.com, www.twitter.com, twitter.com
    'icon-ic-twitter-logo': /^(?:https?:\/\/)?(?:mobile\.|www\.)?twitter\.com(?:\/|$)/,

    // Behance:
    //  www.behance.com, behance.com
    //  www.behance.net, behance.net
    'icon-ic-behance': /^(?:https?:\/\/)?(?:www\.)?(?:behance\.(?:com|net))(?:\/|$)/,

    // LinkedIn:
    //  *.linkedin.com, linkedin.com
    'icon-ic-linkedin': /^(?:https?:\/\/)?(?:[\w]+\.)?linkedin\.com(?:\/|$)/,

    // TikTok:
    //  *.tiktok.com, tiktok.com
    'icon-ic-tiktok': /^(?:https?:\/\/)?(?:[\w]+\.)?tiktok\.com(?:\/|$)/,

    // YouTube:
    //  www.youtube.com, m.youtube.com, youtube.com
    //  www.youtube-nocookie.com, youtube-nocookie.com
    //  www.youtu.be, youtu.be
    'icon-ic-play-button': /^(?:https?:\/\/)?(?:(?:www\.|m\.)?youtube\.com|(?:www\.)?(?:youtube-nocookie\.com|youtu\.be))(?:\/|$)/,

    // Dribbble:
    //  www.dribbble.com, dribbble.com
    'icon-ic-dribbble': /^(?:https?:\/\/)?(?:www\.)?dribbble\.com(?:\/|$)/,

    // Discord:
    //  www.discord.gg, discord.gg
    //  www.discord.io, discord.io
    //  www.discord.me, discord.me
    //  www.discord.li, discord.li
    //  www.discord.com, discord.com
    //  www.discordapp.com, discordapp.com
    'icon-ic-discord': /^(?:https?:\/\/)?(?:www\.)?(?:discord\.(?:gg|io|me|li|com)|discordapp\.com)(?:\/|$)/,
};


/**
 * Returns icon CSS class for the URL
 *
 * Matches URL provided against known social networks and returns respective
 * social network icon CSS class if found. Otherwise, returns a fallback icon
 *
 * @param {string} url link URL
 * @param {string} fallback fallback icon CSS class
 * @returns {string} icon CSS class
 */
const socialIcon = (url, fallback = 'icon-ic-link') => {
    for (const [icon, regex] of Object.entries(regexes)) {
        if (regex.test(url)) return icon;
    }

    return fallback;
};

module.exports = socialIcon;
